export default __webpack_public_path__ + "static/media/colorectal_plot_female.1854bff4.png";